import React from 'react';
import PropTypes from 'prop-types';
import { Toggle as KomodoToggle, Visible } from '@tfecom-thermofisher/react-komodo-design';

import MoreInfo from 'src/components/MoreInfo';
import { Title } from 'src/core/components';

import './Toggle.style.scss';
import {
  MORE_INFO_ALIQUOTS_LINK,
  MORE_INFO_REMAINDERS_LINK,
} from 'src/constants/forms';

const ToggleComponent = ({
  title,
  checked,
  onToggle,
  moreInfoLinkAliquots,
  moreInfoLinkRemainders,
}) => (
  <div>
    <div className="toggle-group">
      <Title size="5" font="medium" message={title} />
      <KomodoToggle
        small
        checked={checked}
        onClick={() => onToggle(!checked)}
      />
    </div>

    <Visible when={moreInfoLinkAliquots}>
      <MoreInfo link={MORE_INFO_ALIQUOTS_LINK} />
    </Visible>

    <Visible when={moreInfoLinkRemainders}>
      <MoreInfo link={MORE_INFO_REMAINDERS_LINK} />
    </Visible>
  </div>
);

ToggleComponent.propTypes = {
  title: PropTypes.object,
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  moreInfoLinkAliquots: PropTypes.string,
  moreInfoLinkRemainders: PropTypes.string,
};

export default ToggleComponent;
